import { useState } from "react";

const KEY = "eb_access_confirmed";

export const hasConfirmedAccess = () => {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return true;
  }
};

const TERMS = [
  {
    n: "01",
    text: "You're 19 or older — the age of majority in your province.",
  },
  {
    n: "02",
    text: "You're here for laboratory or research purposes, where our compounds belong.",
  },
  {
    n: "03",
    text: "You understand our products are for in\u2011vitro study only — never for people or animals.",
  },
];

export const AccessGate = ({ onEnter }) => {
  const [leaving, setLeaving] = useState(false);

  const agree = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {}
    setLeaving(true);
    setTimeout(onEnter, 450);
  };

  return (
    <div
      data-testid="access-gate"
      className={`fixed inset-0 z-[100] overflow-y-auto bg-[#F7F5F2] transition-opacity duration-500 ${leaving ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <style>{`
        @keyframes gateRise { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
        .gate-rise { opacity: 0; animation: gateRise 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards; }
        .gate-ghost { -webkit-text-stroke: 1.5px rgba(201,187,168,0.55); color: transparent; }
      `}</style>

      <div className="min-h-full grid md:grid-cols-5">
        {/* Brand panel */}
        <div className="relative md:col-span-2 bg-[#161310] overflow-hidden flex md:flex-col items-center md:items-start justify-between gap-4 px-6 py-5 md:p-10 md:min-h-screen">
          <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse 90% 70% at 20% 20%, rgba(140,123,107,0.18), transparent 65%)" }} />
          <div className="relative gate-rise" style={{ animationDelay: "0ms" }}>
            <p className="font-display text-[#F7F5F2] text-lg md:text-2xl leading-snug">ETERNAL</p>
            <p className="font-display text-[#8C7B6B] text-lg md:text-2xl leading-snug">BIOLABS</p>
          </div>
          <div className="relative gate-rise md:self-center md:my-auto" style={{ animationDelay: "150ms" }}>
            <p className="font-display gate-ghost text-6xl md:text-[9rem] leading-none select-none" aria-hidden="true">19+</p>
          </div>
          <p className="relative gate-rise hidden md:block text-[10px] tracking-[0.35em] uppercase text-[#6E675F]" style={{ animationDelay: "250ms" }}>
            Research Grade &middot; Canada
          </p>
        </div>

        {/* Acknowledgement panel */}
        <div className="md:col-span-3 flex items-center px-6 py-12 md:px-16 lg:px-24 md:min-h-screen">
          <div className="w-full max-w-xl">
            <p className="gate-rise text-[11px] font-semibold tracking-[0.35em] uppercase text-[#8C7B6B]" style={{ animationDelay: "120ms" }} data-testid="access-gate-eyebrow">
              Welcome to Eternal Biolabs
            </p>

            <h1 className="gate-rise font-display text-3xl md:text-4xl text-[#1A1A1A] mt-4 leading-tight" style={{ animationDelay: "200ms" }}>
              A Quick Word Before You Browse
            </h1>

            <p className="gate-rise text-base text-[#4A453E] leading-relaxed mt-5" style={{ animationDelay: "280ms" }}>
              We're glad you found us. Everything here is made for research — and we take
              that seriously. Just confirm the following and you're in:
            </p>

            <div className="mt-8" data-testid="access-gate-terms">
              {TERMS.map((t, i) => (
                <div
                  key={t.n}
                  className="gate-rise flex items-start gap-5 py-4 border-t border-[#DDD7CF] last:border-b"
                  style={{ animationDelay: `${340 + i * 90}ms` }}
                >
                  <span className="font-display text-sm text-[#8C7B6B] pt-0.5">{t.n}</span>
                  <p className="text-sm text-[#1A1A1A] leading-relaxed">{t.text}</p>
                </div>
              ))}
            </div>

            <div className="gate-rise mt-9 flex flex-col sm:flex-row sm:items-center gap-4" style={{ animationDelay: "660ms" }}>
              <button
                data-testid="access-gate-agree-button"
                onClick={agree}
                className="whitespace-nowrap bg-[#1A1A1A] text-[#F7F5F2] font-semibold text-sm tracking-[0.22em] uppercase rounded-none px-10 py-4 hover:bg-[#8C7B6B] hover:-translate-y-0.5 transition-[background-color,transform] duration-200"
              >
                Sounds Good — Enter
              </button>
              <p className="text-xs text-[#8B8378]">
                Not quite you? No worries — feel free to close this page.
              </p>
            </div>

            <p className="gate-rise mt-10 text-[10px] tracking-[0.3em] uppercase text-[#9A937F]" style={{ animationDelay: "740ms" }} data-testid="access-gate-footer">
              Proudly Canadian <span className="text-[#8C7B6B] mx-1.5">&middot;</span> Independently Verified <span className="text-[#8C7B6B] mx-1.5">&middot;</span> Documentation On Request
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
